import { render, staticRenderFns } from "./TaskNewVisit.vue?vue&type=template&id=5f2b6e0f&"
import script from "./TaskNewVisit.vue?vue&type=script&lang=js&"
export * from "./TaskNewVisit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports